/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import GetAppIcon from '@mui/icons-material/GetApp';
import Tooltip from '@mui/material/Tooltip';
import { Button } from '@mui/material';
import { useToast } from '../../contexts/Toast';
import './Export.scss';
import { useProfile } from '../../contexts/ProfileContext';

function Export({ viz }) {
  const { userInfo } = useProfile();
  const { setToastState } = useToast();

  const tableauAPI = window.tableau;

  const displayErrorToast = (severity, error) => {
    setToastState({
      open: true,
      severity,
      message: error,
    });
  };

  const triggerPDFExport = () => {
    try {
      const exportPDFOptions = {
        scaling: userInfo?.preferences?.pdfScaling || tableauAPI.PrintScaling.Automatic,
        pageSize: userInfo?.preferences?.pdfPagesize || tableauAPI.PrintPageSize.Letter,
        orientation: userInfo?.preferences?.pdfOrientation || tableauAPI.PrintOrientation.Landscape,
      };
      const {publishedSheetsInfo} = viz.workbook;
      const selectedWorkbookSheetsForExport = Array.from(
        publishedSheetsInfo,
        (publishedSheetInfo) => publishedSheetInfo.name,
      );
      viz
        .exportPDFAsync(selectedWorkbookSheetsForExport, exportPDFOptions)
        .then(() => {});
    } catch (err) {
      displayErrorToast('error', err.message);
    }
  };

  const triggerCSVExport = () => {
    try {
      const {activeSheet} = viz.workbook;
      const {worksheets} = activeSheet;
      const selectedWorksheetForExport = worksheets? worksheets[0]: activeSheet;
      const crosstabFileFormat = tableauAPI.CrosstabFileFormat.CSV;
      viz
        .exportCrosstabAsync(selectedWorksheetForExport.name, crosstabFileFormat)
        .then(() => {});
    }
    catch (err) {
      displayErrorToast('error', err.message);
    }
  };

  const triggerExcelExport = () => {
    try {
      const {activeSheet} = viz.workbook;
      const {worksheets} = activeSheet;
      const selectedWorksheetForExport = worksheets?  worksheets[0] : activeSheet;
      const crosstabFileFormat = tableauAPI.CrosstabFileFormat.Excel;
      viz
        .exportCrosstabAsync(selectedWorksheetForExport.name, crosstabFileFormat)
        .then(() => {});
    } catch (err) {
      displayErrorToast('error', err.message);
    }
  };

  return (
    <div className="tableau-vizualization__actions">
      <div>
        <Tooltip title="Open PDF export dialog">
          <Button
            data-cy="criteria-ExportPDF-button"
            className="tableau-vizualization__button"
            variant="contained"
            onClick={triggerPDFExport}
            color="primary"
          >
            <GetAppIcon /> PDF
          </Button>
        </Tooltip>
        <Tooltip title="Download excel">
          <Button
            data-cy="criteria-ExportExcel-button"
            className="tableau-vizualization__button"
            variant="contained"
            onClick={triggerExcelExport}
            color="primary"
          >
            <GetAppIcon /> Excel
          </Button>
        </Tooltip>

        <Tooltip title="Download CSV">
          <Button
            data-cy="criteria-ExportCSV-button"
            className="tableau-vizualization__button"
            variant="contained"
            onClick={triggerCSVExport}
            color="primary"
          >
            <GetAppIcon /> CSV
          </Button>
        </Tooltip>
      </div>
    </div>
  );
}

Export.propTypes = {
  viz: PropTypes.object,
};

export { Export };
